<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <div class="row">
      <b-col md="6">
        <b-form-group
          id="input-group-2"
          label-for="input-2"
          aria-describedby="input-2-live-feedback"
        >
          <template>
            <span>Tên:</span>
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="input-2"
            type="text"
            v-model="formData.name"
            required
            placeholder="Nhập tên"
            size="sm"
            :state="validateState('name')"
          ></b-form-input>
          <b-form-invalid-feedback
            v-if="!$v.formData.name.required"
            id="input-2-live-feedback"
          >Yêu cầu nhập tên danh mục</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          id="input-group-3"
          label-for="input-3"
          aria-describedby="input-2-live-feedback"
        >
          <template>
            <span>Mã:</span>
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="input-3"
            type="text"
            v-model="formData.code"
            required
            placeholder="Nhập mã"
            size="sm"
            :state="validateState('code')"
          ></b-form-input>
          <b-form-invalid-feedback
            v-if="!$v.formData.code.required"
            id="input-3-live-feedback"
          >Yêu cầu nhập mã danh mục</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </div>
    <div class="row">
      <b-col md="6">
        <b-form-group
          id="input-group-3"
          label="Danh mục cha:"
          label-for="input-3"
        >
          <b-form-select
            id="input-1"
            v-model="formData.parentId"
            :options="listCate"
            required
            size="sm"
            value-field="id"
            text-field="name"
            disabled-field="notEnabled"
            class="select-style"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">-- Chọn danh mục cha --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          id="input-group-3"
          label="Loại:"
          label-for="input-3"
        >
          <b-form-select
            id="input-1"
            v-model="formData.type"
            :options="listType"
            required
            size="sm"
            value-field="id"
            text-field="name"
            disabled-field="notEnabled"
            class="select-style"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">-- Chọn loại danh mục --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </div>
    <div class="row">
      <b-col md="6">
        <b-form-group
          id="input-group-3"
          label="Đối tượng:"
          label-for="input-3"
        >
          <b-form-select
            id="input-1"
            v-model="formData.contactId"
            :options="listContact"
            required
            size="sm"
            value-field="id"
            text-field="name"
            disabled-field="notEnabled"
            class="select-style"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">-- Chọn loại đối tượng --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </div>
    <b-button
      style="fontweight: 600; width: 70px; margin-left: 10px;"
      variant="primary"
      size="sm"
      @click="onSubmit"
      v-show="checkPermission('TRANSACTION_CATE_INSERT')"
    >Lưu</b-button>
    <b-button
      style="margin-right: 10px; font-weight: 600; width: 70px"
      variant="secondary"
      size="sm"
      @click="$emit('cancel')"
    >Hủy</b-button>
  </v-form>
</template>

<script>
import { CONTACT_TYPE_CATE } from '@/utils/constants';
import localData from '@/utils/saveDataToLocal';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  name: 'CategoryForm',
  mixins: [validationMixin],
  props: {
    initialData: {
      type: Object,
      default: () => ({
        name: '',
        code: '',
        parentId: null,
        type: null,
        contactId: null,
      }),
    },
    listCate: {
      type: Array,
      default: () => [],
    },
    listType: {
      type: Array,
      default: () => [
        { id: 1, name: 'Thu' },
        { id: 2, name: 'Chi' },
      ],
    },
    listContact: {
      type: Array,
      default: () => CONTACT_TYPE_CATE,
    },
  },
  data() {
    return {
      formData: { ...this.initialData },
    };
  },

  validations: {
    formData: {
      name: { required },
      code: { required },
    },
  },
  computed: {
    ...mapGetters({
      accountants: 'transactionCategory/accountants',
    }),
  },

  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.formData[name];
      return $dirty ? !$error : null;
    },
    isValidData(data) {
      const format = /[`!@#$%^&*()+\-={};':"|,.<>?~]/;
      return !format.test(data);
    },
    checkPermission(permission) {
      return localData.checkPermission(permission);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      if (!this.isValidData(this.formData.name)) {
        alert('Tên danh mục không được chứa ký tự đặc biệt!');
        return;
      }
      if (!this.isValidData(this.formData.code)) {
        alert('Mã danh mục không được chứa ký tự đặc biệt!');
        return;
      }
      this.$emit('submit', this.formData);
    },
  },
};
</script> 
